import { supabase } from '@/lib/supabase/client';
import { Link, createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/')({
  beforeLoad: async () => {
    // Si hay sesion activa, redirigir a la app (workspace o onboarding)
    const { data: userData } = await supabase.auth.getUser();
    const userId = userData.user?.id;
    if (!userId) return;

    const { data: memberships } = await supabase
      .from('workspace_members')
      .select('workspaces!inner(slug)')
      .eq('user_id', userId)
      .limit(1);

    const slug = memberships?.[0]?.workspaces
      ? (memberships[0].workspaces as unknown as { slug: string }).slug
      : undefined;

    if (slug) {
      throw redirect({ to: '/$wsSlug/projects', params: { wsSlug: slug } });
    }
    throw redirect({ to: '/onboarding' });
  },
  component: Landing,
});

function Landing() {
  return (
    <div className="max-w-5xl mx-auto px-6 py-24">
      <section className="text-center">
        <p className="text-sm uppercase tracking-wide text-quiet mb-4">
          Plataforma interna de gestión
        </p>
        <h1 className="text-5xl font-semibold text-ink tracking-tight max-w-3xl mx-auto">
          Trabajo claro.{' '}
          <span
            className="bg-clip-text text-transparent"
            style={{ backgroundImage: 'var(--brand-gradient)' }}
          >
            Equipo alineado.
          </span>
        </h1>
        <p className="mt-6 text-lg text-quiet max-w-2xl mx-auto">
          MEIDEI es la plataforma de gestión de proyectos que usa nuestro equipo de consultoría.
          Acceso por invitación.
        </p>
        <div className="mt-10 flex gap-4 justify-center">
          <Link
            to="/login"
            className="text-white px-6 py-3 rounded-md font-medium"
            style={{ backgroundImage: 'var(--brand-gradient)' }}
          >
            Iniciar sesión
          </Link>
          <a
            href="mailto:osorio.rodrigo@gmail.com?subject=Solicitud de acceso a MEIDEI"
            className="px-6 py-3 rounded-md border border-border text-ink hover:bg-accent-sf"
          >
            Solicitar acceso
          </a>
        </div>
        <p className="mt-4 text-sm text-mute">
          Si ya tienes invitación, recibirás un email con el enlace de acceso.
        </p>
      </section>
    </div>
  );
}
